var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsBtIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.086 -2.7)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.5 3.7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.649,22.053H36.611A1.155,1.155,0,0,0,37.761,20.9a1.188,1.188,0,0,0-1.186-1.149H35.017V17.048a1.773,1.773,0,0,0-1.594-1.78l-2.076-.222a1.159,1.159,0,0,1-.964-.742,1.1,1.1,0,0,1,.185-1.149l1.3-1.594a1.765,1.765,0,0,0-.111-2.373L29.529,6.963a1.766,1.766,0,0,0-2.373-.111l-1.594,1.3a1.182,1.182,0,0,1-1.891-.779l-.222-2.076A1.773,1.773,0,0,0,21.669,3.7H18.555a1.773,1.773,0,0,0-1.78,1.594l-.222,2.15a1.081,1.081,0,0,1-.63.853l-.148.074a1.054,1.054,0,0,1-1.038-.148L13.067,6.852a1.765,1.765,0,0,0-2.373.111L8.469,9.187a1.765,1.765,0,0,0-.111,2.373l1.335,1.668a1.054,1.054,0,0,1,.148,1.038l-.074.148a1.081,1.081,0,0,1-.853.63l-2.113.26a1.773,1.773,0,0,0-1.594,1.78v2.67H3.649a1.149,1.149,0,1,0,0,2.3Zm12.792-3.411a3.671,3.671,0,1,1,7.341,0,3.926,3.926,0,0,1-.185,1.149H16.664A3.021,3.021,0,0,1,16.441,18.642ZM7.468,17.493l1.706-.185a3.241,3.241,0,0,0,2.707-2.039l.074-.148a3.381,3.381,0,0,0-.482-3.337l-1.112-1.3,1.594-1.594L13.29,9.966a3.213,3.213,0,0,0,3.337.482l.148-.074a3.218,3.218,0,0,0,2-2.707L19,6h2.225L21.41,7.63a3.44,3.44,0,0,0,5.6,2.3l1.261-1.038,1.594,1.594-1.038,1.261a3.472,3.472,0,0,0,2.3,5.6l1.631.185v2.225H25.933a5.757,5.757,0,0,0,.111-1.149,5.932,5.932,0,0,0-11.865,0,6.036,6.036,0,0,0,.111,1.149H7.468Z",
    transform: "translate(-2.5 -3.7)",
    fill: "#61748f",
    stroke: "#61748f",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.574,79.51H15.811a3.515,3.515,0,0,0-6.674,0H3.649a1.149,1.149,0,0,0,0,2.3H9.137a3.515,3.515,0,0,0,6.674,0H36.574a1.149,1.149,0,1,0,0-2.3Zm-24.1,2.41a1.261,1.261,0,1,1,1.261-1.261A1.25,1.25,0,0,1,12.474,81.92Z",
    transform: "translate(-2.5 -49.885)",
    fill: "#61748f",
    stroke: "#61748f",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.574,61.21h-6.6a3.515,3.515,0,0,0-6.674,0H3.649a1.149,1.149,0,1,0,0,2.3H23.3a3.515,3.515,0,0,0,6.674,0h6.637a1.155,1.155,0,0,0,1.149-1.149A1.188,1.188,0,0,0,36.574,61.21Zm-9.937,2.41A1.261,1.261,0,1,1,27.9,62.359,1.25,1.25,0,0,1,26.637,63.62Z",
    transform: "translate(-2.5 -38.37)",
    fill: "#61748f",
    stroke: "#61748f",
    strokeWidth: 0.1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsBtIcon);
export default __webpack_public_path__ + "static/media/settings-bt-icon.6c7c79ecea790fbe3f674fd213738f19.svg";
export { ForwardRef as ReactComponent };